import { Reducer } from 'redux'
import {
  RevenueTrackingActionTypes,
  type ReportsData,
  type RevenueInsightsAction,
  initialRevenueInsightsState,
} from './types'

export * from './types'

export const reducer: Reducer<ReportsData, RevenueInsightsAction> = (
  state = initialRevenueInsightsState,
  action
) => {
  switch (action.type) {
    case RevenueTrackingActionTypes.SET_REPORTS_DATA: {
      return {
        ...state,
        ...action.payload,
        noOfPage: Math.ceil(action.payload.count / action.payload.pageSize),
      }
    }
    case RevenueTrackingActionTypes.REVENUE_SET_LIMIT: {
      return {
        ...state,
        pageSize: action.payload,
      }
    }
    case RevenueTrackingActionTypes.REVENUE_SET_PAGE_NUMBER: {
      return {
        ...state,
        pageNumber: action.payload,
      }
    }
    case RevenueTrackingActionTypes.SET_DATE_RANGE: {
      return {
        ...state,
        dateRange: action.payload,
      }
    }
    case RevenueTrackingActionTypes.CLEAR_REVENUE_REPORTS: {
      return {
        ...state,
        rows: [],
        graphData: [],
        totalAmountActivated: '',
        amountChange: '',
        percentageChange: '',
        totalAmountBilled: '',
        totalAmountDisbursed: '',
      }
    }
    default: {
      return state
    }
  }
}
